import { useTranslation } from 'react-i18next';
import { MessageSection, UnsavedChanges } from './PromoForm.styles'

interface ErrorMessagesProps {
    saveProgress?: number;
    areUnsavedChanges?: boolean;
    errorMessage?: string;
}

export default function ErrorMessages({
    saveProgress,
    areUnsavedChanges,
    errorMessage,
} : ErrorMessagesProps) {
    const { t } = useTranslation()

    if (!areUnsavedChanges && errorMessage) {
        return (
            <MessageSection>{t(errorMessage)}</MessageSection>
        )
    }

    if (typeof saveProgress === 'number') {
        if (saveProgress === 1) {
            return (
                <MessageSection>{t('promo-saved')}</MessageSection>
            )
        }

        return (
            <MessageSection>{Math.ceil(saveProgress * 100)}%</MessageSection>
        )
    }

    if (areUnsavedChanges) {
        return (
            <UnsavedChanges>{t('promo-unsaved-changes')}</UnsavedChanges>
        )
    }

    return null
}
